export enum APP_ROUTES {

  // 🔷 PRODUCTS
  PURCHASE_PRODUCT     = '/accounts/product/view-all/purchase',
  INVOICE_PRODUCT      = '/accounts/product/view-all/invoice',
  ORDER_PRODUCT        = '/accounts/product/view-all/',
  ORDER_PRODUCT_CREATE = '/accounts/product/create/',
  ORDER_PRODUCT_UPDATE = '/accounts/product/update/',

  // 🔷 ORDERS
  CREATE_ORDER = '/order/#placeholder/create',
  UPDATE_ORDER = '/order/#placeholder/update',
  VIEW_ORDER   = '/order/#placeholder/view',
  VIEWALL_ORDER_ACCOUNTS = "/accounts/order-accounts",

  // 🔷 CONTACT
  VIEW_CONTACT = '/hrm/customer/view',

  // 🔷 TRANSACTION
  CREATE_TRANSACTION   = '/accounts/transaction/create',
  UPDATE_TRANSACTION   = '/accounts/transaction/update/:id',
  VIEWALL_TRANSACTION = '/accounts/transaction/view-all',
  VIEW_TRANSACTION    = '/accounts/transaction/view/:id',

  // 🔷 TRANSACTION (PWA / MOBILE)
  PWA_EXPENSE_LIST   = '/transactions',
  PWA_CREATE_EXPENSE = '/transactions/create',
  PWA_VIEW_EXPENSE   = '/transactions/:id',
  PWA_EDIT_EXPENSE   = '/transactions/:id/edit',

  // 🔷 WORKSHEET
  VIEWALL_WORKSHEET = '/work/worksheet/:workgroup/view-all',
  VIEW_WORKSHEET    = '/work/worksheet/:workgroup/view',
  CREATE_WORKSHEET  = '/work/worksheet/:workgroup/create',
  UPDATE_WORKSHEET  = '/work/worksheet/:workgroup/update',

  // 🔷 WORK REPORT
  VIEWALL_WORKREPORT = '/work/workreport/:workgroup/view-all',
  VIEW_WORKREPORT    = '/work/workreport/:workgroup/view',
  CREATE_WORKREPORT  = '/work/workreport/:workgroup/create',
  UPDATE_WORKREPORT  = '/work/workreport/:workgroup/update',

  // 🔷 WALLET
  WALLET_VIEWALL = '/accounts/wallet',
  WALLET_VIEW = '/accounts/wallet/:id',

  // Wallet Transactions
  PWA_WALLET_TRANSACTION = '/wallet/wallet-transaction/:id',
  PWA_WALLET_VIEW = '/wallet/:id',

  // 🔷 HRM EXPENSES
  HRM_EXPENSE_PAYEES        = '/hrm/expenses/payees',
  HRM_EXPENSE_PAYEE_DETAILS = '/hrm/expenses/payee/:id',
  HRM_EXPENSE_CATEGORIES    = '/hrm/expenses/categories',
  HRM_EXPENSE_CUSTOMER_VIEW = '/hrm/expenses/customer-view',
  HRM_EXPENSE_ADD           = '/hrm/expenses/add',

  // 🔷 MANAGEMENT
  MANAGE_TAGS     = '/manage/tags/view-all',
  MANAGE_EXPENSES = '/manage/expenses',
  MANAGE_DEVICES  = '/manage/devices',

  // 🔷 REMINDERS
  HRM_REMINDERS   = '/hrm/reminders'
}